import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Box, useTheme} from '@mui/material';
import Grid2 from '@mui/material/Grid';
import emailjs from 'emailjs-com';

const ContactUs = () => {
  const theme = useTheme();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Structure the data to include name, email, and message fields
    const emailData = {
      from_name: formData.name,  // Ensure this matches the template variable in EmailJS
      from_email: formData.email, // Ensure this matches the template variable in EmailJS
      message: formData.message, // Ensure this matches the template variable in EmailJS
    };

    // Use EmailJS to send the structured form data
    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      emailData,
      process.env.REACT_APP_EMAILJS_USER_ID
    )
    .then((response) => {
      console.log('Email sent successfully:', response);
      alert('Your message has been sent successfully!');
      setFormData({ name: '', email: '', message: '' }); // Reset form fields
    })
    .catch((error) => {
      console.error('Failed to send email:', error);
      alert('Failed to send your message. Please try again later.');
    });
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      {/* Page Header */}
      <Typography variant="h1" align="center" gutterBottom sx={{ color: theme.palette.primary.main }}>
        Contact Us
      </Typography>
      <Typography variant="body1" align="center" sx={{ mb: 4 }}>
        We would love to hear from you! Please fill out the form below or contact us using the information provided.
      </Typography>

      {/* Contact Information */}
      <Grid2 container spacing={4} sx={{ mb: 4 }}>
        <Grid2 item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom>
            Email
          </Typography>
          <Typography variant="body2">tonysjswimming@gmail.com</Typography>
        </Grid2>
        <Grid2 item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom>
            Phone
          </Typography>
          <Typography variant="body2">+61 0478 082 050</Typography>
        </Grid2>
      </Grid2>

      {/* Contact Form */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}
      >
        <TextField
          label="Name"
          name="name"
          variant="outlined"
          fullWidth
          required
          value={formData.name}
          onChange={handleChange}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3, // Apply border radius to input
            }
          }}
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          variant="outlined"
          fullWidth
          required
          value={formData.email}
          onChange={handleChange}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3, // Apply border radius to input
            }
          }}
        />
        <TextField
          label="Message"
          name="message"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          required
          value={formData.message}
          onChange={handleChange}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3, // Apply border radius to input
            }
          }}
        />
        <Button 
          type="submit" 
          fullWidth
          variant="contained" 
          color="primary" 
          sx={{ 
            mt: 3, 
            mb: 2, 
            borderRadius: '20px', // Rounded corners for button
          }}
        >
          Send Message
        </Button>
      </Box>
    </Container>
  );
};

export default ContactUs;
